import { debounce } from "lodash-es";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import { toggleMyListItem } from "@/utils/myListActions";

/**
 * Composable for handling bookmark/myList functionality in card components
 * Provides consistent bookmarking behavior with debouncing across all card types
 */
export function useCardBookmark() {
  const store = useStore();
  const route = useRoute();

  const inMyList = computed(() => store.getters["user/inMyList"]);

  const bookmarkMe = (content: any) => {
    toggleMyListItem(content, content.type, {
      inMyList: inMyList.value,
      addContentToMyList: (payload: any) => {
        store.dispatch("user/addContentToMyList", payload);
      },
      removeContentFromMyList: (payload: any) => {
        store.dispatch("user/removeContentFromMyList", payload);
      },
      route,
    });
  };

  const debouncedBookmarkMe = debounce((content: any) => {
    bookmarkMe(content);
  }, 500);

  // Expose store actions for testing compatibility
  const addContentToMyList = (payload: any) =>
    store.dispatch("user/addContentToMyList", payload);

  const removeContentFromMyList = (payload: any) =>
    store.dispatch("user/removeContentFromMyList", payload);

  return {
    inMyList,
    bookmarkMe,
    debouncedBookmarkMe,
    addContentToMyList,
    removeContentFromMyList,
  };
}
